import { jsx as _jsx } from "react/jsx-runtime";
import defaultTheme from "./_defaultTheme";
import ContextProvider from "./providers/ContextProvider";
import SupportChat from "./SupportChat";
const Index = ({ translations = {}, theme = defaultTheme, ...rest }) => {
    return (_jsx(ContextProvider, { translations: translations, theme: theme, children: _jsx(SupportChat, { ...rest }) }));
};
export default Index;
export * from "./types";
export * as utils from "./libs/utilities";
export { default as useSocket } from "./hooks/useSocket";
